export const questionQueryKeys = {
  all: ['question'],
  lists: ['question', 'list'],
  list: (section, decedentId) => ['question', 'list', section, decedentId],
  filledDataEntries: (decedentId) =>
    ['question', 'filled-data-entry', decedentId],
  financialInstitutions: (decedentId) =>
    ['question', 'financial-institutions', decedentId],
  otherFinancialLiabilities: (decedentId) =>
    ['question', 'other-financial-liabilities', decedentId],
  otherCreditCards: (decedentId) =>
    ['question', 'other-credit-cards', decedentId],
};
